import styled from 'styled-components';

export const Middle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
`;

export default Middle
